import React from 'react';
import LocationTemplate from './LocationTemplate';

const SalvoPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Salvo"
      stateName="North Carolina"
      countyName="Dare"
      zipCodes={["27972"]}
      latitude={35.3854}
      longitude={-75.4607}
      population={295}
      historicalFact="Named either for ship salvage operations or a salvo of cannon fire from offshore vessels."
      nearbyTowns={[
        "Avon, NC",
        "Waves, NC",
        "Rodanthe, NC",
        "Buxton, NC",
        "Frisco, NC",
        "Chicamacomico, NC",
        "Pea Island, NC",
        "Hatteras, NC"
      ]}
    />
  );
};

export default SalvoPage;